@if (missing_approvers.length > 0 && !this.skip_approval) {
  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <h4 class="mb-3">{{ 'order_approval' | translate }}</h4>
          @if (approver_missing_warning) {
            <div class="alert alert-warning" role="alert">
              {{ 'one_or_more_approvers_required_warning' | translate }}
            </div>
          }
          <form [formGroup]="form">
            <div class="row g-3">
              @for (approver of missing_approvers; track approver) {
                <div class="col col-12">
                  <ts-select-approvers
                    [id]="approver.id"
                    [label]="approver.title | titlecase"
                    [approver]="approver"
                    [control]="getControl('selected_approver_' + approver.id)"
                    (select_approver)="selectApprover($event, approver.id)"
                  />
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}
